const messages = Object.freeze({
  labelPost: 'Post',
  labelInterview: 'Interview',
  labelPaper: 'Paper',
  labelProject: 'Success Story',
  labelDialog: 'Dialog',
  labelPage: 'Content',
  labelTopic: 'Topic',
  labelTag: 'Tag',
  labelInternalPage: 'Internal Page',
  labelVision: 'Vision',
  labelReport: 'Insurtech Outlook 2023',
  labelEpisode: 'Podcast',
  labelExternalContent: 'External',
  labelEvent: 'Event',
  buttonDialogViewContent: 'Watch dialog',
  buttonDialogViewAllContent: 'Explore all Dialogs',
  buttonPaperViewContent: 'Download paper',
  buttonPaperViewAllContent: 'Explore all Papers',
  buttonPostViewContent: 'Read Post',
  buttonPostViewAllContent: 'Explore all Posts',
  buttonInterviewViewContent: 'Read Interview',
  buttonInterviewViewAllContent: 'Explore all Interviews',
  buttonProjectViewContent: 'Read Success Story',
  buttonProjectViewAllContent: 'Explore all',
  buttonEpisodeViewContent: 'Listen episode',
  buttonEpisodeViewAllContent: 'Listen all episodes',
  buttonExternalViewAllContent: 'Read more',
  buttonEventViewContent: 'Read Event',
  buttonEventViewAllContent: 'Explore all Events',
  buttonDefault: 'Read more',
  buttonTopic: 'Read more on this topic',
  buttonTag: 'Read more on this topic',
  buttonPage: 'Read more',
  buttonEvent: 'Read more',
  buttonInternalPage: 'Read more',
  buttonVision: 'See our Vision',
  buttonReport: 'Download report',
  buttonEpisode: 'Listen episode',
  copiedClipboard: 'Copied to clipboard',
  transcription: 'Transcription'
})

export default messages
